module.exports = __webpack_public_path__ + "img/f14ec38a8e615c9ef860b1d744b04d25.svg";